import { SxProps, Theme, Dialog, Button, Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import colors from "../../theme/Colours";

export const StyledDialog = styled(Dialog)({
  "& .MuiDialog-paper": {
    maxWidth: "730px",
    width: "100%",
    paddingInline: "20px",
    paddingBlock: "25px",
  },
});

export const typographyStyles: SxProps<Theme> = {
  fontFamily: "Montserrat",
  fontWeight: 600,
  fontSize: 18,
};

export const labelTypography: SxProps<Theme> = {
  fontFamily: "Roboto",
  paddingBottom: "8px",
  fontWeight: 500,
  fontSize: "14px",
  color: "#344054",
};

export const DeleteButton = styled(Button)({
  width: "250px",
  fontWeight: 600,
  fontSize: "14px",
  border: `1px solid ${colors.ledgerDeleteBtnColor}`,
  color: colors.ledgerDeleteBtnColor,
  "&.Mui-disabled": {
    color: colors.deleteBtnDisabledColor,
    backgroundColor: colors.deleteBtnBorderColor,
    border: `1px solid ${colors.deleteBtnBorderColor}`,
  },
});

export const ButtonContainer = styled(Box)({
  display: "flex",
  justifyContent: "flex-end",
  marginTop: "35px",
  gap: "30px",
});

export const SaveButton = styled(Button)({
  backgroundColor: colors.primaryButtonOrange,
  width: "250px",
  fontWeight: 600,
  fontSize: "14px",
});

export const Generate = styled(Button)({
  backgroundColor: colors.primaryButtonOrange,
  fontWeight: 600,
  fontSize: "14px",
});

export const generateReceiptButton: SxProps = {
  width: "120px",
  height: "26px",
  minWidth: "unset",
  borderRadius: "2px",
  border: `0.5px solid ${colors.fieldGreyBG}`,
  backgroundColor: colors.fileUploadBG,
  fontFamily: "Roboto",
  fontWeight: 500,
  fontSize: "10px",
  lineHeight: "100%",
  textTransform: "none",
  color: "black",
  padding: 0,
};

export const dividerStyle: SxProps = {
  marginTop: "12px",
  border: `1px solid ${colors.ledgerModalDivider}`,
};

export const creditDialogStyles = {
  "& .MuiDialog-container": {
    alignItems: "flex-start",
  },
  "& .MuiPaper-root": {
    marginTop: "70px",
  },
};

export const dialogActionsStyles: SxProps<Theme> = {
  display: "flex",
  justifyContent: "center",
  gap: "30px",
  marginTop: "8px",
  paddingX: "25px",
  paddingBottom: "35px",
};
